var map = {
	"./decidim/avatar-multiuser.png": 69065,
	"./decidim/brands/google.svg": 20964,
	"./decidim/cc-badge.png": 48287,
	"./decidim/decidim-logo.svg": 51419,
	"./decidim/default-avatar.svg": 70175,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 70629,
	"./decidim/icons.svg": 42878,
	"./decidim/pattern.png": 10093,
	"./decidim/placeholder-card-g.svg": 74594,
	"./decidim/placeholder-card-l.svg": 73225,
	"./decidim/placeholder.jpg": 60056,
	"./decidim/remixicon.symbol.svg": 62394,
	"./decidim/vendor/leaflet/layers-2x.png": 52599,
	"./decidim/vendor/leaflet/layers.png": 89214,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 6707,
	"./decidim/vendor/leaflet/marker-icon.png": 92746,
	"./decidim/vendor/leaflet/marker-shadow.png": 28185,
	"./decidim/vendor/social-share-button/douban.svg": 1789,
	"./decidim/vendor/social-share-button/email.svg": 35454,
	"./decidim/vendor/social-share-button/facebook.svg": 3414,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 54042,
	"./decidim/vendor/social-share-button/hacker_news.svg": 78094,
	"./decidim/vendor/social-share-button/linkedin.svg": 23924,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 34285,
	"./decidim/vendor/social-share-button/pinterest.svg": 80520,
	"./decidim/vendor/social-share-button/reddit.svg": 16994,
	"./decidim/vendor/social-share-button/telegram.svg": 14371,
	"./decidim/vendor/social-share-button/tumblr.svg": 73056,
	"./decidim/vendor/social-share-button/twitter.svg": 37379,
	"./decidim/vendor/social-share-button/vkontakte.svg": 65129,
	"./decidim/vendor/social-share-button/wechat.svg": 38204,
	"./decidim/vendor/social-share-button/whatsapp.svg": 500,
	"./decidim/vendor/social-share-button/x.svg": 75238,
	"./decidim/vendor/social-share-button/xing.svg": 40722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34894;